import { memo } from 'react';

export const DebugThrowError = memo(() => {
  const value: string = null;
  const other = value.trim();

  return (
    <div>Debug Throw Error: {other}</div>
  );
});